<template>
  <div class="row">
    <div class="col s12">
      <div class="control col s12 z-depth-1 white">
        <div class="row">
          <div class="left" style="padding-top: 10px;">
            <span class="title" style="padding-left: 11px;">{{ $t('analysis.detections') }}</span>
          </div>
        </div>
        <h6 v-if="railObject !== null">{{ railObject.ComplexName + ' ' + railObject.Name}}</h6>
        <img v-if="image !== null"
             :src="'data:image/png;base64,' + image"
             :alt="railObject.ComplexName + ' ' + railObject.Name"
             :title="railObject.ComplexName + ' ' + railObject.Name"
             class="detections"
        />
        <div v-else class="card-panel red lighten-4"><h6>{{ $t('analysis.detectionsUnavailable') }}</h6></div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchApi from '../../../services/api/switch/SwitchApi'

export default {
  name: 'DetectionAnalysis',
  components: {},
  props: {
    railObject: {
      required: true
    }
  },
  data () {
    return {
      image: null
    }
  },
  created: function () {
    this.getDetectionsImage()
  },
  computed: {},
  watch: {
    railObject (val) {
      if (val) {
        this.getDetectionsImage()
      }
    }
  },
  methods: {
    getDetectionsImage () {
      SwitchApi.getDetectionsImage(
        this.railObject.RailObjectId)
        .then(result => {
          this.image = result.data
        })
        .catch(() => {
          this.image = null
        })
    }
  }
}
</script>

<style scoped>
  .detections {
    width: 75%;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/analysis/DetectionAnalysis.vue